module.exports = __webpack_public_path__ + "media/images/icons/icon-product_3-6338f81a8f260f610dbcedb3f031f2f3.svg";